<template>
  <div class="flex vertical full-height">
    <div class="scrollable-container main">
      <BackNavigationItem :backNavigation="{ title: 'Zurück', path: '/legal' }" />
      <TosDocument />
    </div>
  </div>
</template>

<script>

import {
  TosDocument
} from "@profineberater/configurator-clientlib"
import BackNavigationItem from "../components/ui/BackNavigationItem.vue";

export default {
  name: 'TosPage',
  components: {
    TosDocument,
    BackNavigationItem
  },
}
</script>
